import { ReactNode } from 'react';

type ConditionalWrapperProps = {
  children: ReactNode;
  condition: boolean;
  className?: string;
};

const ConditionalWrapper = ({
  children,
  className = '',
  condition,
}: ConditionalWrapperProps) => {
  return condition ? <div className={className}>{children}</div> : children;
};

export default ConditionalWrapper;
